import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Briefcase, Bell, PlusCircle } from 'lucide-react';
import { useNotifications } from '../context/NotificationContext';

function MobileBottomNav({ user }) {
    const location = useLocation();
    const { unreadCount, setUnreadCount, refreshCounts } = useNotifications();
    const role = user?.role || 'guest';

    // We hide bottom nav on Messages intentionally to give maximum chat space
    if (location.pathname.startsWith('/messages')) return null;

    const handleNotificationsClick = async () => {
        setUnreadCount(0);
        // Optional: Call API to mark as read here if you don't do it inside the Notifications component
        refreshCounts();
    };

    const navItems = [
        { to: '/', icon: Home, label: 'Home' },
        { to: '/members', icon: Users, label: 'Network' },
        // Center action (Post) handled separately
        { to: '/opportunities', icon: Briefcase, label: 'Jobs', hidden: role === 'guest' },
        { to: '/notifications', icon: Bell, label: 'Alerts', badge: unreadCount, onClick: handleNotificationsClick }
    ].filter(item => !item.hidden);

    return (
        <div className="mobile-bottom-nav">
            {navItems.map((item, index) => {
                const isActive = location.pathname === item.to;

                // Insert the center "Post" button
                if (index === 2 && role !== 'guest') {
                    return (
                        <React.Fragment key="center-actions">
                            {/* Center Post Action */}
                            <Link
                                to="/"
                                // Pass state to auto-open creator if we are navigating to home
                                state={{ openCreator: true }}
                                className="mobile-nav-item center-action"
                            >
                                <div className="center-action-btn">
                                    <PlusCircle size={28} />
                                </div>
                                <span className="mobile-nav-label" style={{ opacity: 0 }}>Post</span>
                            </Link>

                            {/* Right side item (Jobs) */}
                            <Link
                                key={item.to}
                                to={item.to}
                                onClick={item.onClick}
                                className={`mobile-nav-item ${isActive ? 'active' : ''}`}
                            >
                                <div style={{ position: 'relative' }}>
                                    <item.icon size={22} />
                                    {item.badge > 0 && <span className="mobile-nav-badge">{item.badge > 9 ? '9+' : item.badge}</span>}
                                </div>
                                <span className="mobile-nav-label">{item.label}</span>
                            </Link>
                        </React.Fragment>
                    );
                }

                return (
                    <Link
                        key={item.to}
                        to={item.to}
                        onClick={item.onClick}
                        className={`mobile-nav-item ${isActive ? 'active' : ''}`}
                    >
                        <div style={{ position: 'relative' }}>
                            <item.icon size={22} />
                            {item.badge > 0 && <span className="mobile-nav-badge">{item.badge > 9 ? '9+' : item.badge}</span>}
                        </div>
                        <span className="mobile-nav-label">{item.label}</span>
                    </Link>
                );
            })}
        </div>
    );
}

export default MobileBottomNav;
